import api from "./api";

class HospitalService {
  static filter(filterText, pageNumber, recordsPerPage) {
    return api.get(
      `/filter/hospital/${filterText}/${pageNumber}/${recordsPerPage}`
    );
  }
}

export default HospitalService;
